import * as React from "react"
import { Route, Switch, useHistory } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Landing from "./landing"
import ErrorPage from "./error"
import Block from "@bappweb/block"

const Main = () => {
  const routes = React.useMemo(
    () => ({
      Landing,
      Result: () => <Loadable loader={() => import("./result")} />,
      ErrorPage,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  const history = useHistory()
  const queryParams = new URLSearchParams(window.location.search)
  const isError = queryParams.has("hata")

  React.useEffect(() => {
    if (isError) {
      history.push({
        pathname: "/error"
      })
    }
  })

  return (
    <>
      <Block type="main" className="bapp-main">
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path="/result/*" component={routes.Result} />
          <Route path="/error" component={routes.ErrorPage} />
          <Route component={routes.NotFound} />
        </Switch>
      </Block>
    </>
  )
}

export default Main
